export default __webpack_public_path__ + "static/media/port-locafacil.f7f14ffa.webp";